import React from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import Moment from 'react-moment';
import servicioCfdi from '../servicios/ServicioCfdi';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioArchivos from '../servicios/ServicioArchivos';
import servicioCorreo from '../servicios/ServicioCorreo';
import servicioFormatos from '../servicios/ServicioFormatos';
import servicioIdioma from '../servicios/ServicioIdiomaFecha';

export class ConsultaCfdiAdmin extends React.Component {
    constructor() {
        super();
        this.state = {
            cfdi: {},
            erroresFecha: {},
            paginacion: {registrosPorPagina: 20
            },
            inicio: 0,
            criterio: {},
            errorFolioFiscal: {},
            errorFolio: {},
            errorSerie: {},
            errorFecha: {},
            cfdis:[],
            errores:{},
            restriccionSesion:[]
            

        }
        this.formatoTipoComprobante = this.formatoTipoComprobante.bind(this);
    }
    componentDidMount() {
       // this.obtenerPagina();

    }
    formatofechaCreacion = (rowData, column) => {
        return <Moment format="YYYY-MM-DD HH:mm:ss">
          {rowData.ttCfdi.fechaCreacion}
        </Moment>;
      }
    
      formatofechaCertificacion = (rowData, column) => {
    
        if (!rowData.ttCfdi.fechaCertificacion) {
          return "";
        } else {
          return <Moment format="YYYY-MM-DD HH:mm:ss">
            {rowData.ttCfdi.fechaCertificacion}
          </Moment>;
        }
      }
    
    validarFormularioFolioFiscal = (cfdi) => {
        const errores = {};
        if (!cfdi.uuid)
            errores.uuid = "EL folio Fiscal es requerido";
        return errores;
    }
    validarFormularioFolio = (cfdi) => {
        const errores = {};
        if (!cfdi.folio)
            errores.folio = "El folio es requerido";
        return errores;
    }
    validarFormularioSerie = (cfdi) => {
        const errores = {};
        if (!cfdi.serie)
            errores.serie = "La serie es requerido";
        return errores;
    }
    validarFormularioFechas = (cfdi) => {
        const errores = {};
        if (!cfdi.fechaCreacion)
            errores.fechaCreacion = "La fecha inicial es requerida";
        if (!cfdi.fechaCertificacion)
            errores.fechaCertificacion = "La fecha final es requerida";
        return errores;
    }

    validarFormularioRfcReceptor=(receptor)=>{
        const errores = {};
        if (!receptor.rfcReceptor)
            errores.rfcReceptor = "Rfc de Receptor requerida";
        return errores;
    }

    agregarRestriccionSesion = () => {
        let { paginacion, restriccionSesion } = this.state;
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restriccionSesion)) {
            paginacion.restriccionesDinamicas=restriccionSesion;
        }
    }

    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    obtenerPagina() {
        this.agregarRestriccionSesion();
        let { paginacion } = this.state;
        servicioCfdi.paginacion_admin(paginacion).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });
            

        }).catch((error) => {
            if (error)
                return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

    }

    asignarValores(event) {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }

    buscarPorFechas = () => {
       
        let { paginacion, cfdi,restriccionSesion } = this.state;
        const validacion = this.validarFormularioFechas(cfdi);
        this.setState({ errorFecha: validacion });
        if (!Object.keys(validacion).length) {
            paginacion['numeroPagina']=0;
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"between",nombrePropiedad:"alias_ttCfdi.fechaCertificacion",
            valorPropiedad:null,fechaIncialBetween:servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCreacion)+" 00:00:00",
            fechaFinalBetween:servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCertificacion)+" 23:59:59"}];
            restriccionSesion=paginacion.restriccionesDinamicas;
            this.setState({paginacion:paginacion,restriccionSesion});
            this.obtenerPagina();
        }
    }
    buscarSerie = () => {
        let { paginacion, cfdi,restriccionSesion } = this.state;
        const validacion = this.validarFormularioSerie(cfdi);
        this.setState({ errorSerie: validacion });
        if (!Object.keys(validacion).length) {
            paginacion['numeroPagina']=0;
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"eq",nombrePropiedad:"alias_ttCfdi.serie",
            valorPropiedad:cfdi.serie}];
            restriccionSesion=paginacion.restriccionesDinamicas;
            this.setState({paginacion:paginacion,restriccionSesion});
            this.obtenerPagina();
        }
    }
    buscarFolioInterno = () => {
        let { paginacion, cfdi,restriccionSesion } = this.state;
        const validacion = this.validarFormularioFolio(cfdi);
        this.setState({ errorFolio: validacion });
        if (!Object.keys(validacion).length) {
            paginacion['numeroPagina']=0;
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"eq",nombrePropiedad:"alias_ttCfdi.folio",
            valorPropiedad:cfdi.folio}];
            restriccionSesion=paginacion.restriccionesDinamicas;
            this.setState({paginacion:paginacion,restriccionSesion});
            this.obtenerPagina();
        }
    }

    buscarFolioFiscal = () => {
        let { paginacion, cfdi,restriccionSesion } = this.state;
        const validacion = this.validarFormularioFolioFiscal(cfdi);
        this.setState({ errorFolioFiscal: validacion });
        if (!Object.keys(validacion).length) {
            paginacion['numeroPagina']=0;
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"eq",nombrePropiedad:"alias_ttCfdi.uuid",
            valorPropiedad:cfdi.uuid}];
            restriccionSesion=paginacion.restriccionesDinamicas;
            this.setState({paginacion:paginacion,restriccionSesion});
            this.obtenerPagina();
        }
    }

    buscarRfcReceptor = () => {
        let { paginacion, cfdi,restriccionSesion } = this.state;
        const validacion = this.validarFormularioRfcReceptor(cfdi);
        this.setState({ errorFolio: validacion });
        if (!Object.keys(validacion).length) {
            paginacion['numeroPagina']=0;
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"eq",nombrePropiedad:"alias_tcReceptor.rfc",
            valorPropiedad:cfdi.rfcReceptor}];
            restriccionSesion=paginacion.restriccionesDinamicas;
            this.setState({paginacion:paginacion,restriccionSesion});
            this.obtenerPagina();
        }
    }

    plantillaOpciones(rowData, column) {
        return <div className="p-grid">

            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-file-download" className="p-button-danger" name="pdf"
                    tooltip="pdf" >
                </Button>
            </div>
            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-file-download" className="p-button-success" name="xml"
                    tooltip="xml"  >
                </Button>
            </div>
            <div className="p-col-12 p-md-2">
                <Checkbox inputId={column.rowData} value={column.rowData} checked={column.rowData}></Checkbox>
            </div>

        </div>;
    }

    descargaRepresentacionImpresa=(rowData, column)=>{
        return <div>
        <div>
            <Button type="button" icon="pi-md-file-download" className="p-button-danger" name="pdf"
                tooltip="Descargar pdf" onClick={(e) => this.generaDescarga(column.rowData, 'pdf')} >
            </Button>
        </div>
    </div>;
    }

    descargaXmlSaT=(rowData,column)=>{
      
        return <div>
        <div className="p-col-12 p-md-4">
            <Button type="button" icon="pi-md-file-download" className="p-button-success" name="xml"
                tooltip="Descargar xml" onClick={(e) => this.generaDescarga(column.rowData, 'xml')} >
            </Button>
        </div>            
    </div>;
    }

    enviarAmiCorreo=(rowData,column)=>{
        return <div> <Button icon="pi-md-email" onClick={(e) => this.enviaPorCorreo(column.rowData)} className="deep-orange-btn" type="button" tooltip="Enviar a mi correo" 
        ></Button></div>;

    }
    generaDescarga(objeto, tipo) {
        servicioArchivos.descargaArchivo('/documentos/descargar_documentos.json?uuid=' + objeto.ttCfdi.uuid + '&tipo=' + tipo);
      
    }
    enviaPorCorreo(objeto){
        servicioCorreo.enviarAmiCorreo({ttCfdi:objeto.ttCfdi,estado:0,tipo:1,rfcEmisor:objeto.tcEmisor.rfc}).then(response=>{
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'Error'), summary: '', detail: response.data.mensaje });
        })

    }
    asignarCfdis(e) {
        let { cfdis } = this.state;

        if (e.checked)
            cfdis.push(e.value);
        else
            cfdis.splice(cfdis.indexOf(e.value), 1);

        this.setState({ cfdis });

    }
    columnaSeleccionar = (rowData, column) => {
        return <div>
            <div>
            <Checkbox inputId={rowData.uuid} value={rowData} onChange={this.asignarCfdis.bind(this)} checked={this.state.cfdis.includes(rowData)}></Checkbox>
            </div>
        </div>;
    }
    enviarCfdis() {
        let { cfdis, criterio } = this.state;
        let listaEnvio = [];
        if (cfdis.length === 0)
            return this.growl.show({ life: 3000, severity: 'error', summary: 'error', detail: "Selecciona al menos un comprobante" });

        const resultadoValidacion = this.validarCorreo(criterio.correo);
        this.setState({ errores: resultadoValidacion });

        if (!Object.keys(resultadoValidacion).length) {

            cfdis.forEach(cfdi => {
                let correo = {};
                const tcfdi={};
                tcfdi.id=cfdi.ttCfdi.id;
                
                correo['correos'] = criterio.correo;
                correo['estado'] = 0;
                correo['ttCfdi'] = tcfdi;
                correo['tipo'] = 1;
                correo['rfcEmisor'] = cfdi.tcEmisor.rfc;
                listaEnvio.push(correo);

            });
           servicioCorreo.enviarCorreo(listaEnvio).then(response=>{
                this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'Error'), summary: '', detail: response.data.mensaje });
                if(!response.data.error){
                    this.setState({listaEnvio:[],enviocorreo:{},erroresCorreo:{},modalEnvioCorreos:false,cfdis:[]});
                   
                }
            })
        }
    }
    validarCorreo(correo) {
        const errores = {};
        let regularCorreo = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
        if (!correo)
            errores.correo = "El campo es requerido";

        let correos = correo.split(',');
        correos.forEach(nuevoCorreo => {
            if (!regularCorreo.test(nuevoCorreo))
                errores.correo = "Correo o correos inválidos";
        })

        return errores;
    }
    reinicioVariables = () => {


    this.setState({
        cfdi: {},
       
        paginacion: {registrosPorPagina: 20
        },
        inicio: 0,
        criterio: {},
        restriccionSesion:[]
      });
    }
/** poner en el select de estado en la tabla */
formatoTipoComprobante(rowData, column) {
    let tipo = rowData.ttCfdi.tipoFactura;
    let valor = "";
    switch (tipo) {
      case 0:
        valor = "Factura de pagos ";
        break;
      case 1:
        valor = "Factura de emergencia";
        break;
      case 2:
        valor = "Factura de Peaje";
        break;
      case 3:
        valor = "Factura reexpedida";
        break;
      case 4:
        valor = "Ingresos diversos";
        break;
      case 5:
        valor = "Ingresos diversos/Nota de crédito";
        break;
        case 6:
        valor = "Nota de crédito";
        break;  
      default:
        valor = "";
    }
    return <div>
      {valor}
    </div>;
  }
    render() {
        const {criterio,errores, inicio, errorFecha, cfdi, paginacion, errorFolioFiscal, errorFolio, errorSerie } = this.state;
        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title" style={{padding:'14px', display:'flex', alignItems:'center'}}>
                    <h1>Administración de Consultas</h1>
                </div> 
                <div className="card card-w-title">
                <Accordion onTabOpen={this.reinicioVariables} onTabClose={this.reinicioVariables}>
                    <AccordionTab header="Búsqueda por fecha" >
                        <div className="p-grid p-fluid" style={{justifyContent:'space-around', margin:'10px'}}>
                        <p><b>* Fecha Inicial:</b></p>
                            <div className="p-col-12 p-md-3" style={{alignSelf:'center'}}>
                                
                                <Calendar id="fechaCreacion" locale={servicioIdioma} name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValores.bind(this)} className={errorFecha.fechaCreacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                                {errorFecha.fechaCreacion ? <div><br /> <Message severity="error" text={errorFecha.fechaCreacion} /> </div> : null}
                            </div>
                            <p><b>* Fecha Final:</b></p>
                            <div className="p-col-12 p-md-3" style={{alignSelf:'center'}}>          
                                <Calendar id="fechaCertificacion" locale={servicioIdioma} name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValores.bind(this)} className={errorFecha.fechaCertificacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                                {errorFecha.fechaCertificacion ? <div><br /> <Message severity="error" text={errorFecha.fechaCertificacion} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-3" style={{display:'flex', alignSelf:'flex-start'}}>                                
                                <Button label="Buscar" className="p-button-rounded teal-btn flat-btn" onClick={this.buscarPorFechas} />
                            </div>



                        </div>
                    </AccordionTab>
                    <AccordionTab header="Búsqueda por Folio Fiscal">
                    <p style={{margin:'10px 0 0 5px'}}><b>* Folio Fiscal:</b></p>
                        <div className="p-grid p-fluid" style={{margin:'0 10px 10px 0'}}>
                            <div className="p-col-12 p-md-4" style={{alignSelf:'center'}}>
                                
                                <InputText id="uuid" name="cfdi.uuid" value={cfdi.uuid || ''} onChange={this.asignarValores.bind(this)} className={errorFolioFiscal.uuid ? 'p-error' : ''} />
                                {errorFolioFiscal.uuid ? <div><br /> <Message severity="error" text={errorFolioFiscal.uuid} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2" style={{display:'flex', alignSelf:'flex-start'}}>
                                
                                <Button label="Buscar" className="p-button-rounded teal-btn flat-btn" onClick={this.buscarFolioFiscal} />
                            </div>

                        </div>
                    </AccordionTab>

                    <AccordionTab header="Búsqueda por Serie">
                    <p style={{margin:'10px 0 0 5px'}}><b>* Serie:</b></p>
                        <div className="p-grid p-fluid"  style={{margin:'0 10px 10px 0'}}>
                            <div className="p-col-12 p-md-4"  style={{alignSelf:'center'}}>
                                
                                <InputText id="serie" name="cfdi.serie" value={cfdi.serie || ''} onChange={this.asignarValores.bind(this)} className={errorSerie.serie ? 'p-error' : ''} />
                                {errorSerie.serie ? <div><br /> <Message severity="error" text={errorSerie.serie} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2" style={{display:'flex', alignSelf:'flex-start'}}>
                                
                                <Button label="Buscar" className="p-button-rounded teal-btn flat-btn" onClick={this.buscarSerie} />
                            </div>

                        </div>
                    </AccordionTab>

                    <AccordionTab header="Búsqueda por Folio ">
                    <p style={{margin:'10px 0 0 5px'}}><b>* Folio:</b></p>
                        <div className="p-grid p-fluid"  style={{margin:'0 10px 10px 0'}}>
                            <div className="p-col-12 p-md-4"  style={{alignSelf:'center'}}>
                                
                                <InputText id="folio" name="cfdi.folio" value={cfdi.folio || ''} onChange={this.asignarValores.bind(this)} className={errorFolio.folio ? 'p-error' : ''} />
                                {errorFolio.folio ? <div><br /> <Message severity="error" text={errorFolio.folio} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2"  style={{display:'flex', alignSelf:'flex-start'}}>
                                
                                <Button label="Buscar" className="p-button-rounded teal-btn flat-btn" onClick={this.buscarFolioInterno} />
                            </div>

                        </div>
                    </AccordionTab>
                    <AccordionTab header="Búsqueda por RFC Receptor">
                    <p style={{margin:'10px 0 0 5px'}}><b>* RFC Receptor:</b></p>
                        <div className="p-grid p-fluid"  style={{margin:'0 10px 10px 0'}}>
                            <div className="p-col-12 p-md-4"  style={{alignSelf:'center'}}>                                       
                                <InputText id="folio" name="cfdi.rfcReceptor" value={cfdi.rfcReceptor || ''} onChange={this.asignarValores.bind(this)} className={errorFolio.rfcReceptor ? 'p-error' : ''} />
                                {errorFolio.rfcReceptor ? <div><br /> <Message severity="error" text={errorFolio.rfcReceptor} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2"   style={{display:'flex', alignSelf:'flex-start'}}>
                                
                                <Button label="Buscar" className="p-button-rounded teal-btn flat-btn" onClick={this.buscarRfcReceptor} />
                            </div>

                        </div>
                    </AccordionTab>

                </Accordion>
                </div>
                                
                
                <h2 className='title__send-email'>Envío / Reenvío:</h2>                
                
                <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-5">
                <div className="p-inputgroup input__title-email">
                <span className="p-inputgroup-addon"><i className="material-icons">email</i></span>
                <InputText id="correo" name="criterio.correo" className={errores.correo ? 'p-error' : ''}
                 placeholder="ejemplo@dominio.com" tooltip="Para agregar más de un correo debes separarlo por una coma (,) seguido del nuevo correo "
                 value={criterio.correo || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                    </div>
                    {errores.correo ? <div><br /> <Message severity="error" text={errores.correo} /> </div> : null}
                   </div> 
                   <div className="p-col-12 p-md-2">
                                            <Button className="p-button-Primary p-button-raised" label="Enviar"
                                                onClick={this.enviarCfdis.bind(this)} icon="pi-md-mail" tooltip="Enviar a mi correo" />
                                        </div>
                    </div>
                    
                    <div className="p-grid">
        <div className="p-col-12">
          <div className="card card-w-title">
                    <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px"  >

                    <Column header="Varios Correos" body={this.columnaSeleccionar} style={{ width: '4rem', textAlign:'center' }} autoLayout={true} />
                        <Column header="PDF" body={this.descargaRepresentacionImpresa.bind(this)} style={{ width: '3rem', textAlign:'center' }} />
                        <Column header="XML" body={this.descargaXmlSaT.bind(this)} style={{ width: '3rem', textAlign:'center' }} autoLayout={true} />
                        <Column header="Enviar a mi Correo" body={this.enviarAmiCorreo.bind(this)} style={{ width: '3rem', textAlign:'center' }} autoLayout={true} />
                        <Column field="ttCfdi.uuid" header="Folio Fiscal" style={{ width: '5rem', textAlign:'center' }} filter={false} autoLayout={true} />
                        <Column field="ttCfdi.folio" header="Folio" style={{ width: '4rem', textAlign:'center' }} filter={false} autoLayout={true} />
                        <Column field="ttCfdi.serie" header="Serie" style={{ width: '4rem', textAlign:'center' }} filter={false} autoLayout={true} />
                        <Column field="ttCfdi.fechaCreacion" body={this.formatofechaCreacion}  header="Fecha Creación" style={{ width: '5rem', textAlign:'center' }} filter={false} autoLayout={true} />
                        <Column field="tcEmisor.rfc" header="RFC Emisor" style={{ width: '4rem', textAlign:'center' }} filter={false} autoLayout={true} />
                        <Column field="tcReceptor.rfc" header="RFC Receptor" style={{ width: '4rem', textAlign:'center' }} filter={false} autoLayout={true} />
                       
                        <Column field="ttCfdi.tipoComprobante" body={this.formatoTipoComprobante} header="Tipo de Comprobante" style={{ width: '6rem', textAlign:'center' }} filter={false} autoLayout={true} />
                       
                    </DataTable>
                    <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                    </div>
        </div>
      </div>




    </div>);
    }
}